/**
 * La organización que trae un enlace a un chat (`/chat/<id>?org=<orgId>`), y si hay que cambiar a ella.
 *
 * El correo de una derivación (`functions/bot/utils/avisoDeTraspaso.js`) enlaza al chat, y el chat vive
 * bajo UNA organización. `ChatDetalle` lee la ruta de la org ACTIVA, así que un owner de varias que
 * tenga otra activa abriría un chat que «no existe». Con esto, se cambia a la del enlace.
 *
 * Sólo a una organización de la que la persona ES miembro (la lista del contexto): un `?org=` ajeno o
 * inventado no hace nada, y las reglas de Firestore siguen siendo las que deciden qué se puede leer.
 *
 * Función PURA y en CommonJS para probarla desde `functions/__tests__`, que es la única suite que corre
 * en el pre-commit (los tests de `src/` no corren en ningún lado).
 *
 * @param {{ search?: string, activa?: string|null, organizaciones?: Array<{id: string}> }} p
 * @returns {string|null} el id al que cambiar, o null si no hay que cambiar
 */
function orgACambiar({ search = '', activa = null, organizaciones = [] } = {}) {
  let org = null;
  try { org = new URLSearchParams(search).get('org'); } catch { return null; }
  if (!org || org === activa) return null;
  return (organizaciones || []).some((o) => o && o.id === org) ? org : null;
}

module.exports = { orgACambiar };
